import { useAgency } from "../../actions/homeActions";
export default () => {
  const { data: AgencyData, isLoading, isError, error } = useAgency("partner");
  const baseURL = process.env.REACT_APP_BASE_URL;
  const slides = AgencyData?.records || [];
  
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full h-32">
        <p className="text-secondary">Error loading partner: {error.message}</p>
      </div>
    );
  }

  const settings = {
    dots: false,
    infinite: slides.length > 8,
    slidesToShow: slides.length >= 8 ? 8 : slides.length,
    slidesToScroll: 1,
    autoplay: slides.length > 8,
    speed: 3000,
    autoplaySpeed: 0,
    cssEase: "linear",
    pauseOnHover: true,
    arrows: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: slides.length >= 4 ? 4 : slides.length,
          infinite: slides.length > 4,
          autoplay: slides.length > 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: slides.length >= 3 ? 3 : slides.length,
          infinite: slides.length > 3,
          autoplay: slides.length > 3,
        },
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: slides.length >= 3 ? 3 : slides.length,
          infinite: slides.length > 3,
          autoplay: slides.length > 3,
        },
      },
    ],
  };

  return { isLoading, slides, settings, baseURL };
};
